// extracted by mini-css-extract-plugin
module.exports = {"Link":"banner_Link__oaYAM","MobileBanner":"banner_MobileBanner__V4ATF","Banner":"banner_Banner__g4CPZ"};